import { useQuery } from '@tanstack/react-query';
import { getCountryList } from 'app/modules/Auth/services';
import { QueryCacheTime } from 'configs/constants';

export const COUNTRIES_QUERY_KEY = ['auth', 'countries'] as const;

export const useCountries = () => {
  return useQuery({
    queryKey: COUNTRIES_QUERY_KEY,
    queryFn: getCountryList,
    staleTime: Infinity,
    gcTime: QueryCacheTime,
  });
};
